import styled from 'styled-components'

import {
  DeleteOutlined,
  InfoCircleOutlined,
  PlusSquareOutlined,
  MenuOutlined,
  CloseCircleOutlined,
  DownOutlined,
  UpOutlined,
  HeartOutlined,
  HeartFilled,
  EditOutlined,
  FieldTimeOutlined,
  ClockCircleOutlined,
  FilterOutlined,
  CopyOutlined,
} from '@ant-design/icons'

export const TrashIcon = styled(DeleteOutlined)`
  font-size: 30px;
  margin-top: 5px;
  color: #666;
  :hover {
    color: #20a8d8;
  }
`
export const InfoIcon = styled(InfoCircleOutlined)`
  margin-left: 5px;
  display: inline-flex;
  cursor: pointer;
  color: #666;
  :hover {
    color: #20a8d8;
  }
`
export const AddItemIcon = styled(PlusSquareOutlined)`
  font-size: 30px;
  cursor: pointer;
  color: #666;
  :hover {
    color: #20a8d8;
  }
`
export const MenuIcon = styled(MenuOutlined)`
  font-size: 30px;
  cursor: pointer;
  color: #666;
  :hover {
    color: #20a8d8;
  }
`
export const CloseIcon = styled(CloseCircleOutlined)`
  font-size: 30px;
  cursor: pointer;
  color: #666;
  :hover {
    color: #20a8d8;
  }
`
export const DownArrowIcon = styled(DownOutlined)`
  font-size: 10px;
  cursor: pointer;
  color: #666;
  :hover {
    color: #20a8d8;
  }
`
export const UpArraowIcon = styled(UpOutlined)`
  font-size: 10px;
  cursor: pointer;
  color: #666;
  :hover {
    color: #20a8d8;
  }
`
export const HeartFilledIcon = styled(HeartFilled)`
  cursor: pointer;
  font-size: 20px;
  color: #ec6350;
`
export const HeartIcon = styled(HeartOutlined)`
  cursor: pointer;
  font-size: 20px;
  color: #ffffff;
`;

export const EditIcon = styled(EditOutlined)`
  cursor: pointer;
  position: absolute;
  font-size: 20px;
  color: #ffffff;
  right: 35px;
  top: 140px;
`

export const DeleteIcon = styled(DeleteOutlined)`
  cursor: pointer;
  position: absolute;
  font-size: 20px;
  color: #ffffff;
  right: 10px;
  top: 140px;
  :hover {
    color: #20a8d8;
  }
`
export const CopyIcon = styled(CopyOutlined)`
  cursor: pointer;
  font-size: 20px;
  :hover {
    color: #20a8d8;
  }
`
export const PastIcon = styled(FieldTimeOutlined)`
  font-size: 20px;
  color: #ec6350;
  display: inline-flex;
`
export const UpcomingIcon = styled(ClockCircleOutlined)`
  font-size: 20px;
  color: #ec6350;
  display: inline-flex;
`
export const FilterIcon = styled(FilterOutlined)`
  cursor: pointer;
  font-size: 20px;
  right: 10px;
  top: 140px;
  :hover {
    color: #20a8d8;
  }
`
